import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { homePathFor } from '@/lib/roleHome';

// Router-level guard: unauthenticated → login; wrong role → that role's own home (never a blank page)
export const RequireRole = ({ roles, children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="route-guard-loading">
        <Loader2 className="h-8 w-8 animate-spin text-[#20acf6]" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to={homePathFor(user?.role)} replace />;
  return children;
};

// Organisation Admins use their private portal instead of the public marketing site
export const PublicOrPortal = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  if (!loading && isAuthenticated && user?.role === 'org_admin') return <Navigate to="/organisation" replace />;
  return children;
};
